import { FaShareAlt, FaImage } from "react-icons/fa";
import useCustomNavigate from "../../../../hooks/useCustomNavigate";
import { useOutletContext, useParams } from "react-router-dom";
import { getImageUrl } from "../../../../Utils/localStorageUtils";
import { useState } from "react";

const FlatListing = () => {
  const { goTo } = useCustomNavigate();
  const { propertyId } = useParams();
  const { propertyData } = useOutletContext();
  const mediaFiles = propertyData?.mediaFiles || [];

  // ✅ Track image errors using an array
  const [imageErrors, setImageErrors] = useState(new Array(mediaFiles.length).fill(false));

  const handleImageError = (index) => {
    setImageErrors((prev) => {
      const newErrors = [...prev];
      newErrors[index] = true;
      return newErrors; 
    });
  };

  return (
    <div className="p-4">
      <div className="columns-4 gap-4 space-y-4">
        {mediaFiles.length > 0 ? (
          mediaFiles.map((file, index) => {
            const imageUrl = getImageUrl(file?.fileName);
            const imageId = file._id; // Get image ID for query
            return (
              <div
                key={index}
                className="relative break-inside-avoid cursor-pointer"
                onClick={() => goTo(`/propertydetail/${propertyId}/imageswithdetail?imageId=${imageId}`)}
              >
                {imageErrors[index] ? (
                  <div className="flex items-center justify-center w-full h-32 bg-gray-200 rounded-lg">
                    <FaImage className="text-gray-500 text-4xl" />
                  </div>
                ) : (
                  <img
                    src={imageUrl}
                    alt={`Property Image ${index + 1}`}
                    className="w-full object-cover rounded-lg"
                    onError={() => handleImageError(index)} // ✅ Corrected error handling
                  />
                )}
                <span className="absolute top-2 left-2 bg-white text-xs font-semibold px-2 py-1 rounded-md shadow">
                  VIEW {index + 1}
                </span>
              </div>
            );
          })
        ) : (
          <div className="flex justify-center items-center w-full h-40 border rounded-lg bg-gray-100">
            <FaImage className="text-gray-400 text-4xl" />
            <p className="ml-2 text-gray-500">No Images Available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FlatListing;
